import React from 'react'
import _ from 'lodash'

import * as CreditsAndLimitsConstants from './../helpers/constants'

const CreditsSection = ({
  client,
  userData,
  getUserInfo
}) => {

  const creditsInfo = CreditsAndLimitsConstants.CREDITS_LIMITS_TAB[client].CREDITS_SECTION
  return (
    <div className="credits-limits-section">
      <h5 className='text-center'>Credit Breakups</h5>
      <div className='d-flex justify-content-between flex-column gap-2'>
        {creditsInfo.map((opts, idx) => {
          const accessorValue = _.get(userData, opts.accessorKey)
          return (
            <div
              key={idx}
              className='d-flex justify-content-between'
            >
              <p className='m-0'>{opts.label}</p>
              {
                opts.formatter({
                  client,
                  value: accessorValue,
                  userData,
                  getUserInfo
                })
              }
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CreditsSection